import React from "react";
import { FaStar, FaQuoteLeft } from "react-icons/fa";

function Testimonials() {
  const testimonials = [
    {
      name: "Dr. Carlos Eduardo",
      role: "Sócio Fundador",
      text: "O EasyVOG trouxe organizacao real para a equipe. O novo posicionamento visual da home comunica melhor a robustez do produto e passa mais confianca logo na entrada.",
      rating: 5,
    },
    {
      name: "Dra. Ana Paula",
      role: "Advogada Autonoma",
      text: "A combinacao de financeiro, agenda e acompanhamento processual faz muita diferenca. A pagina inicial agora explica isso com mais clareza e elegancia.",
      rating: 5,
    },
    {
      name: "Roberto Almeida",
      role: "Gestor Juridico",
      text: "Quando a apresentacao do sistema e premium, a percepcao de valor sobe. O layout ficou mais alinhado com um software juridico de nivel alto.",
      rating: 5,
    },
  ];

  return (
    <section className="presentation-section">
      <div className="container presentation-shell px-4 px-lg-5 py-5">
        <div className="section-intro text-center mx-auto mb-5">
          <span className="section-kicker">Depoimentos</span>
          <h2 className="section-title">Credibilidade para reforcar a proposta</h2>
          <p className="section-description section-description-muted">
            Depoimentos em cards premium, com contraste melhor e leitura mais
            sofisticada para sustentar a confianca na home.
          </p>
        </div>
        <div className="row g-4 justify-content-center">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="col-md-6 col-lg-4">
              <article className="testimonial-card h-100 hover-lift">
                <FaQuoteLeft className="text-gold opacity-50 mb-3" style={{ fontSize: "2rem" }} />
                <div className="d-flex mb-3">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <FaStar key={i} className="text-gold me-1" />
                  ))}
                </div>
                <p className="testimonial-text flex-grow-1">"{testimonial.text}"</p>
                <div className="d-flex align-items-center">
                  <div className="testimonial-avatar">
                    {testimonial.name.charAt(0)}
                  </div>
                  <div className="ms-3">
                    <h6 className="fw-bold mb-0 text-dark">{testimonial.name}</h6>
                    <small className="text-secondary">{testimonial.role}</small>
                  </div>
                </div>
              </article>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
